export const ANNOUNCED_DISCOUNT_CODE_KEY = 'announcedDiscountCode';
export const PRODUCTS_DATA_KEY = 'productsData';
export const GEOLOCATION_DATA_KEY = 'geolocationData';
